import { Component } from 'react'
import PropTypes from 'prop-types'

/**
 * Error boundary for inline message rendering.
 * Prevents component rendering failures from breaking the entire chat.
 */
class InlineMessageErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    console.error('InlineMessageRenderer error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI - show the raw message content as plain text
      const { message } = this.props
      const content = message.content || message.message || '[Component Error]'

      return (
        <div className="text-sm text-yellow-500">
          <span className="text-yellow-600">⚠️ </span>
          <span className="text-gray-400">{content}</span>
        </div>
      )
    }

    return this.props.children
  }
}

InlineMessageErrorBoundary.propTypes = {
  message: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default InlineMessageErrorBoundary
